import { getStrWithoutSpaces } from 'legacy/lut/components/widgets/public/partner360/helpers/getStrWithoutSpaces'
import { FC } from 'react'

import { Translation } from 'cng-common/features/translations'

import { TBusinessPriotityProgramOffering } from '../../model/types'
import { Pill } from '../pill/Pill'

interface IBusinessPriorityProgramOfferingProps {
  programOffering: TBusinessPriotityProgramOffering
}

export const BusinessPriorityProgramOffering: FC<IBusinessPriorityProgramOfferingProps> = ({
  programOffering,
}) => {
  return (
    <Pill color="blue">
      <Translation span text={`jbp-partner-type-${getStrWithoutSpaces(programOffering)}`} />
    </Pill>
  )
}
